import { useAuth } from "./auth";

export function useCan(perm) {
  const { user } = useAuth();
  const perms = (user && user.permissions) || [];
  if (perms.includes("*")) return true;
  return perms.includes(perm);
}

export function can(user, perm) {
  const perms = (user && user.permissions) || [];
  if (perms.includes("*")) return true;
  return perms.includes(perm);
}
